import React from "react";
import { Link } from "react-router-dom";

export const ActivityGuideLinkMap = Object.freeze({
    // Coaching Activities
    "Affirmations": "1629159438",
    "BringItOn": "1629093928",
    "ConversationWithControl": "1629028406",
    "ConversationWithYourFears": "1629749249",
    "ConversationWithYourPain": "1629749276",
    "ExplorationWithFighting": "1629945857",
    "ExploringFrustration": "1632501761",
    "ExploringTheNeedToFix": "1632763905",
    "Grounding": "1632600070",
    "LeftRightDiscrimination": "1632469030",
    "LettingGo": "1632665629",
    "RestoringBalance": "1632567324",
    "Rewiring": "1632665648",
    "Ruling": "1632534572",
    "Tutorial": "1632665663",
    // Meditation Activities
    "Breathing": "1627717646",
    "GradedMotorImagery": "1627750406",
    "Gratitude": "1627586586",
    "GuidedImagery": "1627684881",
    "GuidedImageryBeach": "1627586597",
    "GuidedMeditation": "1628012545",
    "MuscleRelaxation": "1629061121",
    "SomaticPainting": "1628995601",
    "SomaticTracking": "1629323265",
    "SomaticTrackingExtended": "1629028364",
    "Stargazing": "1628995619",
    // Movement Activities
    "BallRoller": "1619230737",
    "BowAndArrow": "1619427335",
    "CalibrationUpperExtremity": "1620869125",
    "ConnectTheDots": "1621196801",
    "DishStacking": "1621229592",
    "DogFetchHome": "1620967465",
    "FlowerGarden": "1621557276",
    "GolfSwing": "1621721092",
    "GroceryShopping": "1621491756",
    "LotusToss": "1621524528",
    "MatchThree": "1621524538",
    "Mirroring": "1627127823",
    "NeckCalibration": "1669201921",
    "PaintingPuzzles": "1627127839",
    "StarryNight": "1627062289",
    "UnloadDishwasher": "1627324481",
    "Vacuuming": "1627160605"
} as const);

export const ActivityGuideLink = ({
    activityId,
    buttonSize = 42,
    iconSize = 24
}) => {
    return (
        <div
            className="flex flex-shrink-0 justify-center items-center bg-white border-gray-300 rounded-lg shadow hover:bg-gray-100 border relative group"
            style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
        >
            <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 -translate-y-2 bg-gray-800 text-white text-sm rounded shadow-lg px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                Open Activity Guide
            </span>
            <Link
                target="_blank"
                to={`https://karunalabs.atlassian.net/wiki/spaces/Coaching/pages/${ActivityGuideLinkMap[activityId]}`}
            >
                <img
                    className="relative"
                    style={{ width: `${iconSize}px`, height: `${iconSize}px` }}
                    src="/icons/link-external.svg"
                    alt="icon"
                />
            </Link>
        </div>
    )
};